import React, {useEffect, useState} from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  isMobile
} from "react-device-detect";

import ContentModule from "../../modules/content_module";
import BannerSearch from "./Section/BannerSearch";
import BannerBtns from "./Section/BannerBtns";
import HomeBannerImage from "./HomeBannerImage";
import ReviewRatings from "../../modules/review_rating_module";
import CTABtnModule from "../../modules/cta_btn_module";

import ImageModule from "../../modules/image_module";
import {RenderComponent} from "../../modules/render-component";



import "./Banner.scss";


const HomeBanner = ({banner_section, GQLPage}) => {

  //console.log("banner_section", banner_section);

   let local_storage_data = typeof window !== 'undefined' &&  localStorage.getItem('window_wdth') ? localStorage.getItem('window_wdth') : 0;

  const renderComponent = RenderComponent()
  const [window_wdth, setWindowWidth] = useState(local_storage_data)
  const [firstTimeLoad, setFirstTimeLoad] = useState(false);

  useEffect(() => {
    if(typeof window !== 'undefined'){
      if(local_storage_data !== window.innerWidth){
        setWindowWidth(window.innerWidth)
        localStorage.setItem('window_wdth',  window.innerWidth)
      }

      // first time load
      const alreadyVisited = localStorage.getItem("already_visited");
      if (!alreadyVisited) {
        setFirstTimeLoad(true);
        localStorage.setItem("already_visited", "true");
      }
    }
  },[])


  const ImageRenderList = ({banner_section, altText, imagename}) => {

    let image_name = imagename;
    let image_src = banner_section.banner_image
    let processedImages = JSON.stringify({});
    if (GQLPage?.imagetransforms?.banner_section_banner_image_Transforms) {
        processedImages = GQLPage?.imagetransforms?.banner_section_banner_image_Transforms;
    }

    return (
      GQLPage.page_class === "life_landlord_banner" ?
        <ImageModule ImageSrc={image_src} altText={altText} renderer="bgImg"  strapi_id={GQLPage?.id} classNames="banner_img" />
      :
        <ImageModule ImageSrc={image_src} altText={altText} imagetransforms={processedImages} ggfx_results={GQLPage?.ggfx_results} renderer="bgImg" imagename={image_name} strapi_id={GQLPage?.id} classNames="banner_img" />
    )
  }

  const MobileImageRenderList = ({banner_section, altText, imagename}) => {

    let image_name = imagename;
    let image_src = banner_section.banner_image
    let processedImages = JSON.stringify({});

    // if(window_wdth < 768){
    //   if(banner_section?.mobile_banner_image){
    //     image_src = banner_section.mobile_banner_image;
    //     image_name = "pages.banner_section_mobile_banner_image.mobile_banner_image";
    //     if (GQLPage?.imagetransforms?.banner_section_mobile_banner_image_Transforms) {
    //       processedImages = GQLPage?.imagetransforms?.banner_section_mobile_banner_image_Transforms;
    //     }
    //   }
    // }

    if(banner_section?.mobile_banner_image){
      image_src = banner_section.mobile_banner_image;
      image_name = "pages.banner_section_mobile_banner_image.mobile_banner_image";
      if (GQLPage?.imagetransforms?.banner_section_mobile_banner_image_Transforms) {
        processedImages = GQLPage?.imagetransforms?.banner_section_mobile_banner_image_Transforms;
      }
    }

    return (
      GQLPage.page_class === "life_landlord_banner" ?
        <ImageModule ImageSrc={image_src} altText={altText} renderer="bgImg"  strapi_id={GQLPage?.id} classNames="banner_img" />
      :
        <ImageModule ImageSrc={image_src} altText={altText} imagetransforms={processedImages} ggfx_results={GQLPage?.ggfx_results} renderer="bgImg" imagename={image_name} strapi_id={GQLPage?.id} classNames="banner_img" />
    )
  }

  console.log("firstTimeLoad", firstTimeLoad);

  let banner_name = `${GQLPage?.menu?.slug}-banner.jpg`

  return (

      <section className={`banner banner_mbl ${banner_section?.banner_style}`}>
        {/* <span className="banner_img" style={{backgroundImage:`url(${banner_section?.banner_image?.url})`}}></span> */}

        {banner_section?.banner_image &&
        <>
          {/* <ImageRenderList banner_section={banner_section} altText={banner_section?.title} imagename = "pages.banner_section_banner_image.landing_banner_image"  /> */}

          {/* {renderComponent === "false" && 
            <>
              <HomeBannerImage file_name={banner_name} /> 
              <span className="transp_bg banner_clr"></span>
            </>
          } */}

            { isMobile ?
              <>
                {/* {firstTimeLoad ?
                  <HomeBannerImage file_name={banner_name} /> 
                :
                  <MobileImageRenderList banner_section={banner_section} altText={banner_section?.title} imagename = "pages.banner_section_banner_image.landing_banner_image"  /> 
                } */}
                <HomeBannerImage file_name={banner_name} />
                <span className="transp_bg banner_clr"></span>
              </>

            :
              <>
                <HomeBannerImage file_name={banner_name} /> 
                <span className="transp_bg banner_clr"></span>
              </>
            }

            {/* <>
              <HomeBannerImage file_name={banner_name} /> 
              <span className="transp_bg banner_clr"></span>
            </> */}
        </>
        }    

        <Container>
          <Row>
            <Col className="md-12">
              
                {(banner_section.title || banner_section.content) && 
                    <div className="banner-content position-relative">
                      
                        {banner_section?.title && <h1>{banner_section.title}</h1> }

                        {banner_section?.content && (
                            <p className="sm-text">
                                <ContentModule Content={banner_section.content}/>
                            </p>
                        )
                        }

                        <div className="banner_container">
                          <Container>
                              {(banner_section?.button_cta_1?.label || banner_section?.button_cta_2?.label) && 
                                <BannerBtns banner_section={banner_section} strapi_id={GQLPage?.id}/>
                              }

                              {banner_section?.button_cta?.length > 0 && 
                                <div className="btn-wrapper">

                                {banner_section?.button_cta.map((cta, i)=> {
                                  return(
                                    <CTABtnModule button_cta={cta}/>
                                  )
                                }) }
                                </div>
                              }

                              {banner_section?.show_search === "property_search" && 
                                <BannerSearch GQLPage={GQLPage} />
                              }


                              {(renderComponent === "true" && banner_section?.show_reviews && (process.env.GATSBY_TrustpilotBussinessID || process.env.GATSBY_TRUSTPILOT_BUSSINESS_ID)) &&
                                <ReviewRatings page="home" />
                              }
                          </Container>
                        </div>

                    </div>
                }

            </Col>
          </Row>
        </Container>
      </section>

  );
};
export default HomeBanner;